/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type:  * `archiveActivation` - Count of archive ERS activations per month  * `archiveBillable` - Count of billable archive ERS per month. Billable ERS means active ERS or disable ERS in retention period time.  * `archiveBillableExternal` - Count of billable external archive ERS per month. Billable external ERS means active ERS or disable ERS in retention period time. 
 */
export enum UsageTypeEnumDTO {
    ARCHIVE_ACTIVATION = 'archiveActivation',
    ARCHIVE_BILLABLE = 'archiveBillable',
    ARCHIVE_BILLABLE_EXTERNAL = 'archiveBillableExternal'
}

export class ClsUsageTypeEnumDTO {
    ARCHIVE_ACTIVATION = 'archiveActivation';
    ARCHIVE_BILLABLE = 'archiveBillable';
    ARCHIVE_BILLABLE_EXTERNAL = 'archiveBillableExternal';
}

